__turbopack_context__.v({
  "container": "RelatedBlogsSection-module-scss-module__a_1ezW__container",
  "slide": "RelatedBlogsSection-module-scss-module__a_1ezW__slide",
});
